import Head from 'next/head';
import { Box, Container, Typography} from '@mui/material';
import { DashboardLayout } from '../dashboard-layout';
import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useParams } from 'react-router-dom';
import OrderSummary from './OrderSummary';

const db = app.firestore();

const ViewOrder = () => {
  const { id } = useParams();
  
  return (
    <>
      <Head>
        <title>
          Détails livraison
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth="md">
          <Typography
            sx={{ mb: 3 }}
            variant="h4"
          >
            Les détails de la livraison
          </Typography>
          <OrderSummary orderId={id} isUpdate={true}/>
          {/* <Box sx={{ mt: 3 }}>
            <OrdersFullPanel />
          </Box> */}
        </Container>
      </Box>
    </>
  );
}

ViewOrder.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default ViewOrder;
